import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_BANDITS_PSF_COMBO_EXPERIMENT = defineFcm('revenue_bandits_psf_combo_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string', optional: true },
				exp_name_suffix: { type: 'string', optional: true },
				treatment_traffic_percentage: { type: 'number', min: 0, max: 100 },
				enabled: { type: 'boolean' },
				bandit_amounts: {
					type: 'array',
					shape: {
						type: 'number',
					},
					optional: true,
				},
				contextual_button_amounts: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							amounts: {
								type: 'array',
								shape: {
									type: 'number',
								},
							},
						},
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
